module.exports = __webpack_public_path__ + "static/media/tecma_logo.ae8f4948.svg";